<div class="header-container-home full-height">
  <div class="profile-section">
    <div class="profile-container" (click)="toggleAccountSettings()">
      <app-wallet-profile-orb class="profile-container__chain-icon" />
      <div class="profile-container__info">
        <div class="profile-container__wallet-name">{{ walletName() }}</div>
      </div>
    </div>
  </div>
  <div class="network-selection-section">
    <div class="network-info" (click)="onNetworkSelectionClick()">
      <div class="network-icon">
        @if (currentNetworkInfo().icon) {
          <img [src]="currentNetworkInfo()!.icon!" alt="" class="chain-icon" />
        } @else {
          <span class="chain-icon" aria-label="Generic network icon" role="img"
            >🌐</span
          >
        }
      </div>
      <div class="network-name">
        {{ currentNetworkInfo().name || "Kaspa L1" }}
      </div>
    </div>

    <kc-icon
      class="settings-icon"
      [iconClass]="'icon-settings'"
      [size]="'md'"
      (click)="onSettingsClick()"
      kcTooltip="Settings"
      tooltipPosition="bottom-center"
    />

    @if (!desktopViewService.isIframe) {
      <kc-icon-button
        class="expand-toggle"
        [icon]="
          desktopViewService.isExpandedView()
            ? 'icon-fullscreen-exit'
            : 'icon-fullscreen'
        "
        [size]="'sm'"
        [variant]="'secondary'"
        (buttonClick)="desktopViewService.toggle()"
        [title]="
          desktopViewService.isExpandedView() ? 'Compact view' : 'Expand view'
        "
        [ariaLabel]="
          desktopViewService.isExpandedView() ? 'Compact view' : 'Expand view'
        "
      />
    }
  </div>
</div>
